import React from "react";

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
  error?: unknown;
};

export class RootErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: unknown): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    // Surface a useful stack in console for debugging
    console.error("[RootErrorBoundary]", error);
    console.error("[RootErrorBoundary componentStack]", info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6">
          <div className="max-w-md w-full rounded-xl border border-border bg-background p-6 text-center">
            <h1 className="text-xl font-semibold text-foreground">Något gick fel</h1>
            <p className="mt-2 text-sm text-muted-foreground">
              Ladda om sidan. Om problemet kvarstår, kolla konsolen för detaljer (RootErrorBoundary).
            </p>
            <button
              className="mt-4 inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-primary-foreground"
              onClick={() => window.location.reload()}
            >
              Ladda om
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
